export default "__VITE_ASSET__DVitpgEi__"